// extracted by mini-css-extract-plugin
module.exports = {"expectedReturnChart":"Chart-module--expectedReturnChart--A6MHo"};